import React from "react";
import { useNavigate } from "react-router-dom";
import HeroSection from "./HeroSection";
import FeatureSection from "./FeatureSection";
import Footer from "./Footer";
import { AttendanceMockup, EmergencyMockup } from "./Mockups";

import "./landing.css";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="landing">
      <HeroSection />

      {/* Quick value strip */}
      <section className="landing-section" style={{ paddingTop: 56, paddingBottom: 56 }}>
        <div className="landing-inner">
          <div className="stat-strip">
            <div className="stat-item">
              <div className="stat-num">Seconds</div>
              <div className="stat-label">to sign a student out or in</div>
            </div>
            <div className="stat-item">
              <div className="stat-num">Real-time</div>
              <div className="stat-label">school-wide student visibility</div>
            </div>
            <div className="stat-item">
              <div className="stat-num">Zero paper</div>
              <div className="stat-label">sign-out sheets to chase down</div>
            </div>
          </div>
        </div>
      </section>

      <FeatureSection />

      {/* How it works */}
      <section className="landing-section">
        <div className="landing-inner">
          <div className="landing-section-head">
            <span className="landing-eyebrow">Get going in minutes</span>
            <h2>Up and running in three simple steps</h2>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-num">1</div>
              <h3>Create your account</h3>
              <p>
                Sign up free, join your school, and add your classes and student
                rosters — or import the ones already there.
              </p>
            </div>
            <div className="step">
              <div className="step-num">2</div>
              <h3>Students check in & out</h3>
              <p>
                Kids tap to mark attendance or sign out to the bathroom, nurse,
                or office. Every action is logged automatically.
              </p>
            </div>
            <div className="step">
              <div className="step-num">3</div>
              <h3>Stay in the know</h3>
              <p>
                See who's out at a glance, review the history, and account for
                everyone instantly when an emergency drill hits.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Built by a teacher */}
      <section className="landing-section landing-section--tint">
        <div className="landing-inner maker-grid">
          <div className="maker-mocks">
            <div className="mock--back">
              <EmergencyMockup />
            </div>
            <div className="mock--front">
              <AttendanceMockup />
            </div>
          </div>
          <div className="maker-text">
            <span className="landing-eyebrow">Created by teachers, for teachers</span>
            <h2>Built from real classroom experience</h2>
            <p className="landing-lead">
              ClassBoon was designed by a 5th-grade teacher who was tired of
              paper sign-out sheets and never quite knowing where every student
              was. Every feature solves a problem teachers actually face.
            </p>
            <p className="maker-quote">
              “I wanted something I could trust during a fire drill and still
              love using on a normal Tuesday.”
            </p>
            <p className="maker-sign">— A fellow teacher</p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="landing-section landing-section--navy cta-band">
        <div className="landing-inner">
          <h2>Ready to know exactly where your students are?</h2>
          <p className="landing-lead">
            Join the teachers using ClassBoon to make sign-outs, attendance, and
            emergencies effortless. It's free to get started.
          </p>
          <div className="cta-actions">
            <button
              className="landing-btn landing-btn--light"
              onClick={() => navigate("/register")}
            >
              Create a free account
            </button>
            <button
              className="landing-btn landing-btn--ghost"
              onClick={() => navigate("/loginform")}
              style={{ color: "#fff", borderColor: "rgba(255,255,255,0.6)" }}
            >
              Sign in
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;
